// src/components/BBS/BBSHeader.js
import React from 'react';

export default function BBSHeader({ title, subtitle }) {
  return (
    <div className="bbs-header">
      <h1 className="bbs-title">OPHIDIA GLOBAL BBS TERMINAL</h1>
      {title && (
        <div className="bbs-subtitle" style={{ color: '#00e5ff', fontSize: '1.2rem', marginTop: '8px' }}>
          {'// '}{title}
        </div>
      )}
      {subtitle && (
        <div className="bbs-subtitle">{subtitle}</div>
      )}
      <div className="bbs-tagline">
        ▓ GOD IS WIRE. GOD IS FEAR. ▓
      </div>
    </div>
  );
}